import { Col, Typography } from "antd";
import { CustomDatePicker } from "../../../shared/formFields/CustomDatePicker";

const { Text } = Typography;

// A bound policy can take effect on a past or future calendar day, so override
// CustomDatePicker's default `disabledDate` (which blocks future dates) and allow
// any date. The only constraint — expiry strictly after effective — together with
// the "both required" rule is enforced in ApplicationsQuote and surfaced as inline
// field errors via react-hook-form.
const allowAnyDate = () => false;

const PolicyDateFields = ({ control }) => (
  <>
    <Col span={24}>
      <Text strong>Policy Effective Date:</Text>
    </Col>
    <Col span={24}>
      <CustomDatePicker
        control={control}
        name="policy_effective_date"
        placeholder="Select a date"
        disabledDate={allowAnyDate}
        formItem={{ style: { marginBottom: 8 } }}
      />
    </Col>
    <Col span={24}>
      <Text strong>Policy Expiry Date:</Text>
    </Col>
    <Col span={24}>
      <CustomDatePicker
        control={control}
        name="policy_expiry_date"
        placeholder="Select a date"
        disabledDate={allowAnyDate}
        formItem={{ style: { marginBottom: 16 } }}
      />
    </Col>
  </>
);

export default PolicyDateFields;
